import { Fragment, useContext } from 'react';
import Link from 'next/link';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { makeStyles } from 'tss-react/mui';
import MenuIcon from '@mui/icons-material/Menu';
import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import AppContext from '../contexts/app';
import HeaderAuth from './header-auth';

const useStyles = makeStyles()((theme) => ({
  appBar: {
    borderBottom: `2px solid ${theme.palette.primary.main}`,
    backgroundColor: '#fff',
  },
  toolbar: {
    flexWrap: 'wrap',
    minHeight: 50,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
    },
  },
  toolbarTitle: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'baseline',
    fontSize: 24,
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
  },
  toolbarTitleLink: {
    textDecoration: 'none',
    color: theme.palette.text.primary,
    fontFamily: 'var(--font-sriracha), "Sriracha", sans-serif',
  },
  toolbarTitleCity: {
    textDecoration: 'none',
    color: theme.palette.primary.main,
    fontWeight: 'normal',
    fontFamily: 'var(--font-sriracha), "Sriracha", sans-serif',
  },
  mobileDrawerButton: {
  },
  homeIcon: {
    color: 'rgba(0, 0, 0, 0.87)',
    margin: theme.spacing(0, 1),
  },
  cityIcon: {
    color: theme.palette.text.secondary,
    margin: theme.spacing(0, 1),
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0
    },
    '@media (max-width:360px)': {
      display: 'none'
    }
  },
  mobileOnly: {
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  },
  desktopOnly: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  headerLinks: {
    display: 'flex',
    alignItems: 'center',
  },
  headerDesktopLinks: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  }
}));

const Header = () => {
  const {
    setMobileDrawerOpen,
    mobileDrawerOpen,
    city,
  } = useContext(AppContext);
  const { classes } = useStyles();

  return (
    <AppBar position="static" elevation={0} className={classes.appBar}>
      <Toolbar component="nav" className={classes.toolbar}>
        <Box sx={{ display: { xs: 'block', md: 'none' } }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={() => setMobileDrawerOpen(!mobileDrawerOpen)}
            edge="start"
            className={classes.mobileDrawerButton}
          >
            <MenuIcon htmlColor="#000" />
          </IconButton>
        </Box>
        <Typography className={classes.toolbarTitle}>
          <Link href="/calendar" className={classes.toolbarTitleLink}>
            Everyday Rides{city && (
              <Fragment>
                {' '}
                <span className={classes.toolbarTitleCity}>
                  {city.name}
                </span>
              </Fragment>
            )}
          </Link>
        </Typography>
        <div className={classes.headerLinks}>
          <Box sx={{ display: { xs: 'none', sm: 'flex' } }} className={classes.headerDesktopLinks}>
            <Button
              component={Link}
              href="/events/new"
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              sx={{ mx: 1.5 }}
            >
              Add Event
            </Button>
          </Box>
          <HeaderAuth />
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
